// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1R3LF","label":"Radio_label__3Qszk","checkMark":"Radio_checkMark__1Ac90","disabled":"Radio_disabled__3X80A"};